module.exports = __webpack_public_path__ + "static/img/p1.0466ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p1.png
// module id = a5wx
// module chunks = 0